import moment from 'moment';

export const getEmployees = state => state.all;
export const getArchivedEmployees = state => state.archived;
export const getCoordinators = state => state.coordinators;
export const getDirectors = state => state.directors;
export const getDirectorAndCoordinators = (state) => [ ...state.coordinators, ...state.directors ];
export const getEmployee = state => state.employee;
export const getOriginalEmployee = state => state.originalEmployee;

export const getDirectorOrCoordinatorById = (state) => (id) => {
    return [ ...state.coordinators, ...state.directors ].find(item => item.userId === id);
};

export const getDirectorById = (state) => (id) => {
    return state.directors.find(item => item.userId === id);
};

export const getRoles = state => state.roles;

export const getDepartments = state => state.departments;

export const getSalaryHistory = state => state.employee.salaryHistory;

export const getSearchEmployees = state => state.searchEmployees;

export const getUploadingPhoto = state => state.uploadingPhoto;

export const getUserVacationDays = state => state.employee.vacationDays;

export const getEmployeeRocketChat = state => state.employee.rocketChat;

export const getEmployeeProbationDate = state => state.employee.probationDate;

export const getSalaryChangeReason = state => state.newSalary.changeReason;

export const getGoogleAccountInfo = state => state.employee.googleAccountInfo;

export const getCurrencies = state => state.currencies;

export const getEmployeePassword = state => state.employee.password;

export const getFacilityTypes = state => state.facilityTypes;

export const getFacilityDevices = state => state.facilityDevices;

export const getBenefits = state => state.benefits;

export const getContactEmail = state => state.employee.contactEmail;

export const getPositions = state => state.employee.positions && state.employee.positions.length > 0
    ? state.employee.positions.map(position => {
        position.contractStart = formatDate(position.contractStart);
        position.contractLapse = formatDate(position.contractLapse);
        position.probationDate = formatDate(position.probationDate);
        return position;
    })
    : [{position: ''}];

function formatDate(date) {
    return date ? moment(date).format('YYYY-MM-DD') : null;
}



// WEBPACK FOOTER //
// ./src/store/modules/employees/getters.js